
export enum EnvironmentCd {
	DEV = 'Dev',
	PRE_PROD = 'PreProd',
	PROD = 'Prod',
	TEST = 'Test'}
